module.exports = "/_next/static/images/75c288f0ab44d97fe0411f51aaa2b48b-slide-1.png";